import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  supportLinkContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    '& a': {
      marginLeft: '0',
    },
  },
}));
